import React from 'react';

interface ProgressBarProps {
  progress: number; // 0-1 value
  label: string; // e.g., "Crafting Progress:", "Mining Progress:"
  timeRemaining?: number | undefined; // in seconds
  isComplete?: boolean;
  completedText?: string; // e.g., "✓ Complete", "✓ Ready to output"
  readyText?: string; // e.g., "Ready to craft", "Ready to output"
  waitingText?: string; // e.g., "Waiting for inputs"
  showReadyWaiting?: boolean; // Whether to show ready/waiting status when idle
  canStart?: boolean; // Whether the operation can start (for ready/waiting logic)
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  label,
  timeRemaining,
  isComplete = false,
  completedText = '✓ Complete',
  readyText = 'Ready',
  waitingText = 'Waiting',
  showReadyWaiting = false,
  canStart = true,
}) => {
  return (
    <div className='crafting-progress-section'>
      <div className='crafting-status'>
        <span className='crafting-label'>{label}</span>
        <div className='progress-bar-container'>
          <div className='progress-bar'>
            <div
              className='progress-fill'
              style={{
                width: `${(progress * 100).toFixed(1)}%`,
              }}
            />
          </div>
          <span className='progress-text'>{(progress * 100).toFixed(1)}%</span>
        </div>
        <div className='crafting-time-info'>
          {progress > 0 && progress < 1 && timeRemaining !== undefined ? (
            <span className='time-remaining'>
              Time remaining: {timeRemaining.toFixed(1)}s
            </span>
          ) : isComplete || progress >= 1 ? (
            <span className='crafting-complete'>{completedText}</span>
          ) : showReadyWaiting ? (
            <div className='idle-status'>
              <span className='idle-label'>Status: </span>
              {canStart ? (
                <span className='ready-status'>{readyText}</span>
              ) : (
                <span className='waiting-status'>{waitingText}</span>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
